/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_All_LabelInputs */



/**
* | output |
* | --- |
* | "all" |
*
* @param {Error_Nav_All_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_all_label = /** @type {((inputs?: Error_Nav_All_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_All_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("toutes")
	if (locale === "de") return /** @type {LocalizedString} */ ("alle")
	if (locale === "it") return /** @type {LocalizedString} */ ("Tutto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("все")
	if (locale === "es") return /** @type {LocalizedString} */ ("todo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("全部")
	if (locale === "ja") return /** @type {LocalizedString} */ ("全て")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("todos")
	return /** @type {LocalizedString} */ ("all")
});